module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/background.6998e1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/background.jpg
// module id = vskU
// module chunks = 1